import { render, staticRenderFns } from "./choosePeople.vue?vue&type=template&id=7e0daae3&lang=pug"
import script from "./choosePeople.vue?vue&type=script&lang=js"
export * from "./choosePeople.vue?vue&type=script&lang=js"
import style0 from "./choosePeople.vue?vue&type=style&index=0&id=7e0daae3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports